import axios from 'axios';
import Cookies from 'js-cookie';

const api = axios.create();

api.interceptors.request.use((config) => {
  const token = Cookies.get('authToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      Cookies.remove('authToken');
      localStorage.removeItem('fintechId');
      localStorage.removeItem('adminId');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
